import { render, staticRenderFns } from "./TouchpointStatisticsTraffic.vue?vue&type=template&id=cd094a72&scoped=true&"
import script from "./TouchpointStatisticsTraffic.vue?vue&type=script&lang=js&"
export * from "./TouchpointStatisticsTraffic.vue?vue&type=script&lang=js&"
import style0 from "../../../../Style/touchpoint-statistics.scss?vue&type=style&index=0&id=cd094a72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd094a72",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd094a72')) {
      api.createRecord('cd094a72', component.options)
    } else {
      api.reload('cd094a72', component.options)
    }
    module.hot.accept("./TouchpointStatisticsTraffic.vue?vue&type=template&id=cd094a72&scoped=true&", function () {
      api.rerender('cd094a72', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/TouchpointOverview/Statistics/TouchpointStatisticsTraffic.vue"
export default component.exports